import React, {useEffect, useState} from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import BotonPampaAzul from "../../Buttons/BotonAzulPampa";
import clienteAxios from '../../../service/axios';

const useStyles = makeStyles((theme) => ({
    root: {
        display:"flex",
        flexDirection:"column",
        height: "300px",
        width: "40vw",
        minWidth:"250px",
    },
    time:{
        display:"flex", 
        flexDirection:"row-reverse", 
        textAlign:"rigth",
        height:"3em !important",
        width:"100%",/* 
        marginBottom:"1em" */
    },
    text:{
        width:"100%",
        padding:"0px 0px 1em 0px",
    },
    button:{
        display:"flex",
        flexDirection:"column",
        heigth:"4em",
    }
  }));
export default function Descargo({index,disable,lista,rol, alert}) {
    const classes = useStyles();
    const [current, setCurrent] = useState() 
    const [descargo, setDescargo] = useState({descargo:""})
    //
    useEffect(() => {
        setCurrent(lista[index])     
    }, []);
    const onChange = (e) => {
        setDescargo({
            ...descargo,
            [e.target.name]: e.target.value,
        });
    };
    const onSubmit = (e) => {
        e.preventDefault();
        disable(index,descargo.descargo,lista,rol)
    }
    const fecha = () => {
        if (current){
            let dia= current.fecha.slice(8,10)
            let mes= current.fecha.slice(5,7)
            let año= current.fecha.slice(0,4)
        return dia +"/"+mes+"/"+año
        }
    }
    const sendRequest = async (log,descargo) => {
        let resultado = "";
        let temp = ""
        resultado = await clienteAxios.put(`/log/desactivar/${log._id}`,{"descargo":descargo});
        if (temp.data) {
            resultado = temp.data.status
        }
        return resultado
    }

    return (
        <Grid container direction="column" alignItems="flex-end" spacing={1}>
            <Grid item xs={12}>
                <Typography component="p" variant="body1" style={{color:"grey", fontSize: 20}}>
                    Notificación recibida a las {current && current.hora.slice(0,5)} del {fecha()}
                </Typography>
            </Grid>
            <Grid item xs={12} lg={12} md={12}>
                <TextField
                    id="outlined-multiline-static"
                    label="Motivo de Alerta"
                    multiline
                    autoFocus
                    fullWidth
                    rows={8}
                    name="descargo"
                    defaultValue=""
                    variant="outlined"
                    value={descargo.descargo}
                    onChange={onChange}
                    style={{width: "550px"}}
                />
            </Grid>
            <Grid item xs={4}>
                <BotonPampaAzul
                    onClick={onSubmit}
                    disable={descargo.descargo===""}
                />
            </Grid>
        </Grid>
    )
}
